import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';
import { LanguageService } from "src/app/services/language/language.service"

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Daniel-portfolio';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private languageService: LanguageService
  ) {
  }
  ngOnInit(): void {

    this.languageService.initLanguage()

    this.titleService.setTitle("Daniel Bassey | Angular / Ionic Developer | MEAN Stack Development | Software Engineer | Frontend Engineer");
    this.metaService.addTags([
      { name: 'keywords', content: 'Frontend, MEAN Stack Developer, Software Engineer, Software, Developer' },
      { name: 'description', content: 'As a frontend engineer with expertise in both Angular and Ionic, I have a comprehensive understanding of full-stack web development. My strong foundation in JavaScript and typescript allows me to effectively work with front-end technologies, as well as back-end technologies such as Node.js and Express.' },
    ]);
    
    AOS.init();
  }
}
